// src/components/LanguageSwitcher.tsx
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../i18n'; // Adjust the import path as necessary
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'; // For dropdown icon


const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
        setIsOpen(false); // Close dropdown after selection

  };

  const flagMap: Record<string, string> = {
    'en': '🇬🇧',
    'zh-CN': '🇨🇳',
    'ms': '🇲🇾',
    'th': '🇹🇭',
  };

  const currentLanguage = supportedLanguages.find(lang => lang.code === i18n.resolvedLanguage) || supportedLanguages[0];

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative language-switcher md:ml-4 my-1 md:my-0" ref={dropdownRef}>
     
      <button

        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center px-1 py-1 text-sm text-black bg-white rounded border border-gray-300 md:text-black md:border-transparent hover:bg-gray-100 md:hover:bg-blue-100 focus:outline-none w-full md:w-auto justify-between md:justify-start"
      >
        <span className="mr-2">{flagMap[currentLanguage.code]}</span>
        <span className="hidden md:inline">{currentLanguage.name}</span>
        <span className="md:hidden flex-grow text-left">{currentLanguage.name}</span> {/* Show name on mobile button */}
        {isOpen ? <FiChevronUp className="ml-1" /> : <FiChevronDown className="ml-1" />}
     
      </button>


      {isOpen && (
        <div className="absolute right-0 mt-1 w-full md:w-40 bg-white rounded-md shadow-lg z-20 py-0.5 border md:border-gray-200">
          {supportedLanguages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              disabled={i18n.resolvedLanguage === lang.code}
              className={`w-full text-left flex items-center px-2 py-0.5 text-sm ${
                i18n.resolvedLanguage === lang.code
                  ? 'bg-blue-800 text-white'
                  : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
              } disabled:opacity-80`}
            >
              <span className="mr-2">{flagMap[lang.code]}</span>
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>

  );
};

export default LanguageSwitcher;